import { httpClient } from '../../httpClient/httpClient';
import { ChatThread } from './chatApi';
import { ChatMessageRequestData } from './richTextTypes';

export const aiAgentApi = {
  newSession: (data: ChatMessageRequestData) =>
    httpClient.post<ChatThread[]>(`ai/session`, { data }),
  generalPrompt: (data: ChatMessageRequestData) =>
    httpClient.put('ai/prompt', { data }),
};
